import { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import "./index.css";

// redux imports
import {
  ownerAccountsViewAll,
  ownerAccountsBalanceRefresh,
  setshowsuccestoast,
  setToggle,
  ownerAccountsRemoveTag,
  ownerAccountsAddTag,
  ownerAccountsRemoveLabel,
  ownerAccountsAddLabel,
  resetToggle,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";

// components imports
import OwnerAccountViewAllCard from "../OwnerAccountViewAllCard/index";
import OwnerAccountListView from "../../../../components/Accounts/OwnerAccount/OwnerAcoountListView/index";
import OwnerAccountRefreshAllLoader from "../../../../components/Accounts/OwnerAccount/OwnerAccountRefreshAllLoader/index";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index";
import OwnerAllStatement from "../OwnerAccountConsolidatedBankStatement";
import Loader from "../../../../components/Loader/Index";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import {
  GlobalConfiguration,
  PaginationConfiguration,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import SwitcherTabsWithSplitView from "../../../../components/_utils/CommonButtons/SwitcherTabWithSplitView";
import TopNavComponentWithBalance from "../../../../components/_utils/CommonTopNav/TopNavComponentTotalBalance";
import CommonAssignTagPopup from "../../../../components/_utils/CommonPopups/CommonAssignTagPoppup";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";
import globalText from "../../../../utils/globalText";
import useMultiSelect from "../../../../utils/useMultiSelect";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";
import UseHandleScroll from "../../../../hooks/useHandleScroll";

const OwnerAccountViewAll = ({
  typepop,
  setOpenOwner,
  setIsNeft,
  setIsImps,
  setIsRtgs,
  txnPayLoad,
  setTxnPayLoad,
  BenEnableNextButton,
  handleButtonClick,
  flow,
  owneraccountNumber,
  setownerAccountNumber,
  owneraccountnumberstate,
  setowneraccountnumberstate,
  multiSelect,
  onClosed,
  setDefaultAccountNumber,
  owneraccountDefaultNumber,
  popType,
  setRefactorAccDetail,
  type,
  setpaymentBox,
  selectedLabelsCreate,
  TypeRTGS,
  currentAccountDetails,
}) => {
  const location = useLocation();
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleClearSearchParam, handleSearchParams } =
    useCustomSearchParams(
      location?.state && location?.state?.approvalStatus
        ? {
            connectbank: location?.state?.approvalStatus,
            pageno: GlobalConfiguration.lengthCheckOne,
            pagesize: dropdownOptions[0],
          }
        : {
            pageno: GlobalConfiguration.lengthCheckOne,
            pagesize: dropdownOptions[0],
          },
    );

  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [loading, setLoading] = useState(true);
  const { startDate: bankStatementStartDate, endDate: bankStatementEndDate } =
    useSelector((state) => state.ownerAllVerification);

  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [tagsOptions, setTagsOptions] = useState([]);
  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );

  const {
    ownerAccBalanceLoading,
    ownerAccBalanceError,
    toggle,
    showSuccessToast,
  } = useSelector((state) => state.ownerAllVerification);

  const [searchUserTextDebounce, setsearchUserTextDebounce] = useState("");
  const [mainData, setMainData] = useState([]);

  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);

  const [inputData, setInputData] = useState([]);

  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");

  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    toggle
      ? GlobalConfiguration.ownerAccountListHoverHeightWithRefresh
      : GlobalConfiguration.ownerAccountCardHoverHeightWithRefresh,
  );

  const [accData, setAccData] = useState("");
  const [viewStatementOpenPop, setViewstatementOpenPop] = useState(false);
  const [statementId, setStatementId] = useState("");
  const [total_balance_state, setTotal_balance_state] = useState(0);
  const [prev_total_balance_state, setPrev_Total_balance_state] = useState(0);
  const [refreshAllData, setRefreshAllData] = useState([]);
  const [successRefreshId, setSuccessRefreshId] = useState([]);
  const [failedRefreshId, setFailedRefreshId] = useState([]);
  const [refreshType, setRefreshtype] = useState("");
  const [selectAmtType, setSelectAmtType] = useState("Default");
  const [refreshAll, setRefreshAll] = useState(false);
  const [splitView, setSplitView] = useState("");
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [connectedbankingstate, setConnectedbankingstate] = useState(
    typepop === "popup" && flow !== "internalTxn"
      ? "Active"
      : searchParam.get("connectbank") || "",
  );
  const [typeaccountstate, settypeaccountstate] = useState(
    searchParam.get("acctype") || "",
  );
  const [bankstate, setbankstate] = useState(searchParam.get("bank") || "");
  const [accountbalancestate, setaccountbalancestate] = useState(
    searchParam.get("sort") || "",
  );
  const [accountnumberstate, setaccountnumberstate] = useState(
    searchParam.get("accno") || "",
  );
  const [ifscstate, setifscstate] = useState(searchParam.get("ifsc") || "");
  const [panstate, setpanstate] = useState(searchParam.get("pan") || "");
  const [ownerTagState, setOwnerTagState] = useState(
    searchParam.get("tag")?.split(",") || [],
  );
  const [isAssignTagsClicked, setIsAssignTagsClicked] = useState(false);
  const [assignTagsAccounts, setAssignTagsAccounts] = useState([]);
  const [newSelectedTags, setNewSelectedTags] = useState([]);
  const [AllTags, setAllTags] = useState([]);
  const [isTagsPopupOpen, setIsTagsPopupOpen] = useState(false);
  const [selectedAssignedAccountID, setSelectedAssignedAccountID] =
    useState("");
  const [selectedAccount, setSelectedAccount] = useState(
    "All selected accounts",
  );
  const [allData, setAllData] = useState([]);
  const [sortBy, setSortBy] = useState(
    searchParam.get("sort_by")
      ? searchParam.get("sort_by")
      : accountbalancestate
        ? ""
        : "latest",
  );
  const [favouritesFilter, setFavouritesFilter] = useState(
    location?.state?.filter
      ? location?.state?.filter
      : searchParam.get("favourite") || "",
  );
  const [allSelected, setAllSelected] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const indicatorRef = useRef(null);
  const balanceSelectorRef = useRef(null);
  const {
    handleChange,
    handleSelectAll: handleMultiSelectAll,
    handleSingleSelect,
  } = useMultiSelect();

  const AccountTypeMapper = {
    "Current account": "Current Account",
    "Overdraft account": "Overdraft Account",
    "Cash credit account": "CACC",
    "Fixed deposit account": "Fixed Deposit Account",
  };

  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [labelAccounts, setLabelAccounts] = useState([]);
  const [labelsFilter, setFilterLabels] = useState(
    searchParam.get("label")?.split(",") || [],
  );
  const [labels, setLabels] = useState([]);

  const labelActionDispatchedRef = useRef(false);
  const tagActionDispatchedRef = useRef(false);

  const scrollContainerRef = useRef(null);

  const handleScrollToTop = () => {
    const scrollTarget = scrollContainerRef.current || window;
    scrollTarget.scrollTo({
      top: GlobalConfiguration.lengthCheckZero,
      behavior: "smooth",
    });
  };

  const services = useSelector((state) => state.refreshToken.services);

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { showRestrictedAction } = useRestrictedAction();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filterRef = useRef(null);
  const setScrollableContainerRef = (node) => {
    scrollContainerRef.current = node;
    filterRef.current = node;
  };

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const handleMount = async () => {};

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < ScreenSizeConfiguration.tabviewEnd;
      if (isMobile) {
        setSplitView(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    dispatch(enableSwitcher());
    handleMount();
    return () => {
      dispatch(disableSwitcher());
      dispatch(resetToggle());
    };
  }, [markerData]);

  useEffect(() => {
    if (isAssignTagsClicked || isLabelClicked) dispatch(disableSwitcher());
    else dispatch(enableSwitcher());
  }, [isAssignTagsClicked, isLabelClicked]);

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("AvailableLabelsOwner");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [
    markerData,
    currentPage,
    toggle,
    searchUserText,
    pageSize,
    favouritesFilter,
    accountnumberstate,
    panstate,
    ifscstate,
    connectedbankingstate,
    accountbalancestate,
    typeaccountstate,
    ownerTagState,
    labelsFilter,
    bankstate,
    sortBy,
  ]);

  let availableTags = mainData?.summary?.available_tags || tagsOptions || [];

  const getSelectedIds = (selectedAccounts = []) =>
    selectedAccounts
      ?.map((account) => account?.id || account)
      ?.filter(Boolean) || [];

  const assignTagsAccountIds = getSelectedIds(assignTagsAccounts);
  const labelAccountIds = getSelectedIds(labelAccounts);
  const activeSelection = isAssignTagsClicked
    ? assignTagsAccounts
    : isLabelClicked
      ? labelAccounts
      : owneraccountnumberstate;
  const activeSelectionCount =
    activeSelection?.length || GlobalConfiguration.lengthCheckZero;
  const isMultiSelectLimitReached =
    owneraccountnumberstate?.length >=
    GlobalConfiguration.owneraccountnormalLength;

  const selectedTagsCards = accumulatedData?.filter((account) =>
    assignTagsAccountIds.includes(account.id),
  );

  const fetchData = async () => {
    setFailedRefreshId([]);
    setSuccessRefreshId([]);
    setRefreshtype(false);

    try {
      setLoading(true);

      let response = await dispatch(
        ownerAccountsViewAll({
          page_no: currentPage,
          page_size: pageSize,
          search_string: searchUserText?.length ? searchUserText : undefined,
          type_of_account: typeaccountstate?.length
            ? AccountTypeMapper[typeaccountstate]
            : undefined,

          bank_name: bankstate?.length ? bankstate : undefined,
          connected_banking:
            typepop === "popup" && flow !== "internalTxn"
              ? "Y"
              : connectedbankingstate?.length
                ? connectedbankingstate === "Active"
                  ? "Y"
                  : "N"
                : undefined,
          bank_account_no: accountnumberstate?.length
            ? accountnumberstate
            : undefined,
          ifsc: ifscstate?.length ? ifscstate : undefined,
          pan: panstate?.length ? panstate : undefined,
          sort_by_balance: accountbalancestate?.length
            ? accountbalancestate
            : undefined,
          sort_by: sortBy,
          tag: favouritesFilter
            ? ""
            : ownerTagState?.length && !favouritesFilter
              ? ownerTagState
              : undefined,
          labels: favouritesFilter
            ? ""
            : labelsFilter?.length && !favouritesFilter
              ? labelsFilter
              : undefined,
          favourite:
            favouritesFilter === "Show only favourite"
              ? "Y"
              : favouritesFilter === "Hide favourite"
                ? "N"
                : undefined,
        }),
      );

      if (
        !(
          favouritesFilter ||
          searchUserText?.length ||
          connectedbankingstate?.length ||
          accountbalancestate?.length ||
          ownerTagState?.length ||
          labelsFilter?.length ||
          typeaccountstate?.length ||
          bankstate?.length ||
          panstate?.length ||
          accountnumberstate?.length ||
          ifscstate?.length
        ) ||
        (location?.state &&
          bankOptions?.length === GlobalConfiguration.lengthCheckZero) ||
        (location?.state && !typeaccountstate?.length)
      ) {
        setBankOptions(response?.payload?.summary?.available_banks || []);
        setTagsOptions(response?.payload?.summary?.available_tags || []);
      } else {
        if (sessionStorage?.getItem("AvailableTags")) {
          let val = sessionStorage?.getItem("AvailableTags");
          setTagsOptions(JSON.parse(val) || []);
        }
      }
      const newData = response?.payload?.owner_accounts || [];
      setMainData(response?.payload);
      setTotal_balance_state(Number(response?.payload?.total_balance || 0));
      setAccumulatedData(newData);
      setAllData((prev) => {
        return [
          ...new Map(
            [...prev, ...newData].map((item) => [item["id"], item]),
          ).values(),
        ];
      });
      setLoading(false);

      if (
        response?.payload?.response?.data?.errors?.user_unauthorized?.length
      ) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "VAccount" },
        });
      }
    } catch (error) {
      setAccumulatedData([]);
      setMainData([]);
      setLoading(false);
    }
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    if ((isAssignTagsClicked || isLabelClicked) && !multiSelect) {
      const selectedAccounts = isAssignTagsClicked
        ? assignTagsAccounts
        : labelAccounts;
      const setSelectedAccounts = isAssignTagsClicked
        ? setAssignTagsAccounts
        : setLabelAccounts;

      if (selectedAccounts?.length > value) {
        handleChange(
          selectedAccounts,
          setSelectedAccounts,
          value,
          selectableAccounts,
        );
      }
    }
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSelectedValue(value);
    setPageSize(value);
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      UniversalRefreshToast();
    }
    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();

        if (showSuccessToast) {
          setTimeout(() => {
            CommonToast({
              text: "Balance refreshed successfully.",
              icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              variant: "var(--success)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
            dispatch(setshowsuccestoast());
          }, 250);
        }
      }, 500);
    }
  }, [ownerAccBalanceLoading]);

  const handleAddTags = async (item) => {
    if (tagActionDispatchedRef) {
      tagActionDispatchedRef.current = true;
    }

    try {
      setLoading(true);
      let tagsToAdd;
      if (typeof item === "string") {
        tagsToAdd = [item];
      } else if (item?.type === "newAss" && Array.isArray(item?.data1)) {
        tagsToAdd = item.data1;
      } else {
        throw new Error("Invalid item format");
      }
      const response = await dispatch(
        ownerAccountsAddTag({
          owner_id:
            selectedAssignedAccountID !== ""
              ? [selectedAssignedAccountID]
              : assignTagsAccountIds,
          tags: tagsToAdd,
        }),
      );

      if (response?.payload?.status === true) {
        let val = allData.map((itm) => {
          if (assignTagsAccountIds.includes(itm.id)) {
            return {
              ...itm,
              tags: [
                ...new Set([
                  ...(itm.tags || []),
                  ...(response?.meta?.arg?.tags || []),
                ]),
              ],
            };
          }
          return itm;
        });
        setAllData(val);
        await fetchData();
        toast.dismiss();
        CommonToast({
          text: <>Tags assigned successfully.</>,
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error adding tags:", error);
      CommonToast({
        text: error.message || "An error occurred while adding the tags.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const handleRemoveTags = async (item) => {
    if (tagActionDispatchedRef) {
      tagActionDispatchedRef.current = true;
    }

    try {
      setLoading(true);

      const response = await dispatch(
        ownerAccountsRemoveTag({
          owner_id:
            selectedAssignedAccountID !== ""
              ? [selectedAssignedAccountID]
              : assignTagsAccountIds,
          tags: item,
        }),
      );

      if (ownerAccountsRemoveTag.fulfilled.match(response)) {
        toast.dismiss();
        CommonToast({
          text: "Tags unassigned successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }

      if (ownerAccountsRemoveTag.rejected.match(response)) {
        toast.dismiss();
        CommonToast({
          text: getErrorMessage(response),
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }

      if (response?.payload?.status === true) {
        let val = allData.map((itm) => {
          if (assignTagsAccountIds.includes(itm.id)) {
            return {
              ...itm,
              tags: itm.tags.filter(
                (tag) => !response?.meta?.arg?.tags?.includes(tag),
              ),
            };
          }
          return itm;
        });
        setAllData(val);

        setLoading(true);
      } else {
        setLoading(false);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error removing tag:", error);
    }
  };

  useEffect(() => {
    const selectedButton = balanceSelectorRef.current?.querySelector(
      `[data-type="${selectAmtType}"]`,
    );

    if (selectedButton && indicatorRef.current && balanceSelectorRef.current) {
      const buttonRect = selectedButton.getBoundingClientRect();
      const containerRect = balanceSelectorRef.current.getBoundingClientRect();

      const offsetLeft = buttonRect.left - containerRect.left;
      const offsetWidth = buttonRect.width;

      indicatorRef.current.style.left = `${offsetLeft + 5}px`;
      indicatorRef.current.style.width = `${offsetWidth - 9}px`;
    }
  }, [selectAmtType]);

  const handleRefresh = async (id) => {
    try {
      let response = await dispatch(ownerAccountsBalanceRefresh(id));
      if (response?.payload?.status == true) {
        setSuccessRefreshId([id]);
        let balance = 0;
        let data = accumulatedData.map((item) => {
          if (
            response.payload?.owner_accounts?.[0]?.owner_account_id === item?.id
          ) {
            balance =
              Number(total_balance_state) -
              Number(item?.owner_account_balance) +
              Number(
                response.payload?.owner_accounts?.[0]?.owner_account_balance,
              );
            return {
              ...item,
              owner_account_balance_last_fetched_at_in_words:
                response.payload?.owner_accounts?.[0]
                  ?.owner_account_balance_last_fetched_at_in_words,
              owner_account_balance:
                response.payload?.owner_accounts?.[0]?.owner_account_balance,
              owner_account_balance_last_fetched_at:
                response.payload?.owner_accounts?.[0]
                  ?.owner_account_balance_last_fetched_at,
              difference: Math.abs(
                Number(item?.owner_account_balance) -
                  Number(
                    response.payload?.owner_accounts?.[0]
                      ?.owner_account_balance,
                  ),
              ),
              increaseOrDecrease:
                Number(item?.owner_account_balance) >
                Number(
                  response?.payload?.owner_accounts?.[0]?.owner_account_balance,
                )
                  ? "decreased"
                  : Number(item?.owner_account_balance) <
                      Number(
                        response.payload?.owner_accounts?.[0]
                          ?.owner_account_balance,
                      )
                    ? "increased"
                    : "",
            };
          }
          return item;
        });
        setTotal_balance_state(Number(balance));
        setAccumulatedData(data);
      } else {
        setFailedRefreshId([id]);

        setTimeout(() => {
          toast.dismiss();
          CommonToast({
            text: response?.payload?.response?.data?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ],
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
          });
        }, 500);
      }
    } catch (error) {
      CommonToast({
        text: error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      throw error;
    }
  };

  const filteredData = accumulatedData;
  const selectableAccounts = filteredData?.map((account) => ({
    ...account,
    id: account?.id,
  }));
  const isEmptyDataState = !filteredData?.length || !accumulatedData?.length;
  const postiveBalanceData = accumulatedData.filter(
    (item) =>
      item.connected_banking == "Y" && Number(item.owner_account_balance) >= 0,
  );
  const negativeBalanceData = accumulatedData.filter(
    (item) =>
      item.connected_banking == "Y" && Number(item.owner_account_balance) < 0,
  );

  const handlePagination = (page) => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop =
        GlobalConfiguration.lengthCheckZero;
    }
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const handleViewStatement = () => {
    setViewstatementOpenPop(true);
  };

  const fetchFilterData = async () => {
    let data = [];
    setLoadingData(true);
    switch (active) {
      case "Labels":
        data = labels
          ?.filter((itm) => {
            if (itm.includes(searchUserTextDebounce)) return itm;
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;

      case "Bank name":
        data = bankOptions
          ?.filter((itm) => {
            if (itm?.toLowerCase().includes(searchUserTextDebounce)) return itm;
          })
          ?.map((val) => {
            return { id: val, Bank_name: val };
          });
        setInputData(data);
        setLoadingData(false);

        break;

      case "Tags":
        data = tagsOptions
          ?.filter((itm) => {
            if (itm.includes(searchUserTextDebounce)) return itm;
          })
          ?.map((val) => {
            return { id: val, Tag: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;
      case "Search":
        setSearchUserText(searchUserTextDebounce);
        setLoadingData(false);
        break;
      default:
        setLoadingData(false);
        break;
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchFilterData();
    }
  }, [active]);

  useEffect(() => {
    if (selectedAccount !== "All selected accounts") {
      const selectedAccountTags =
        allData?.find((account) => account.id === selectedAssignedAccountID)
          ?.tags || [];

      setNewSelectedTags(
        selectedAccountTags.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );

      setAllTags(
        availableTags?.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    } else if (
      selectedTagsCards?.length &&
      selectedAccount !== "All selected accounts"
    ) {
      const accountTags =
        allData?.find((account) => assignTagsAccountIds.includes(account.id))
          ?.tags || [];
      setNewSelectedTags(
        accountTags.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
      setAllTags(
        availableTags?.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    } else if (
      selectedTagsCards?.length ||
      selectedAccount === "All selected accounts"
    ) {
      let a = allData?.filter((account) =>
        assignTagsAccountIds.includes(account.id),
      );
      const commonTags = a.reduce((common, account) => {
        return common.filter((tag) => account.tags?.includes(tag));
      }, a[0]?.tags || []);

      const uncommonTags = a.reduce((uncommon, account) => {
        return uncommon.concat(
          account.tags?.filter((tag) => !commonTags.includes(tag)) || [],
        );
      }, []);

      setNewSelectedTags(
        commonTags.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );

      setAllTags(
        [...new Set([...availableTags, ...uncommonTags])].map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    } else {
      setNewSelectedTags([]);
      setAllTags(
        availableTags?.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    }
  }, [
    assignTagsAccounts,
    selectedAssignedAccountID,
    accumulatedData,
    mainData,
    accumulatedData,
    allData,
  ]);

  const handleSelectAll = () => {
    const maxOwnerAccounts = GlobalConfiguration.owneraccountnormalLength;
    if (!owneraccountnumberstate?.length) {
      setowneraccountnumberstate(() => {
        return filteredData
          ?.slice(GlobalConfiguration.lengthCheckZero, maxOwnerAccounts)
          ?.map((ac) => {
            return ac.id;
          });
      });
    } else if (
      owneraccountnumberstate?.length === maxOwnerAccounts &&
      !searchUserText?.length &&
      !accountbalancestate?.length &&
      !ownerTagState?.length &&
      !labelsFilter?.length &&
      !typeaccountstate?.length &&
      !bankstate?.length &&
      !panstate?.length &&
      !accountnumberstate?.length &&
      !ifscstate?.length
    ) {
      setowneraccountnumberstate([]);
    } else if (
      (searchUserText?.length ||
        accountbalancestate?.length ||
        ownerTagState?.length ||
        labelsFilter?.length ||
        typeaccountstate?.length ||
        bankstate?.length ||
        panstate?.length ||
        accountnumberstate?.length ||
        ifscstate?.length > 0) &&
      owneraccountnumberstate?.length === maxOwnerAccounts &&
      filteredData?.every((ac) => {
        return owneraccountnumberstate?.includes(ac.id);
      })
    ) {
      let arr = [...owneraccountnumberstate];
      for (
        let i = GlobalConfiguration.lengthCheckZero;
        i < filteredData?.length;
        i++
      ) {
        if (owneraccountnumberstate?.includes(filteredData[i].id)) {
          arr = arr.filter((ac) => {
            return ac !== filteredData[i].id;
          });
        }
      }
      setowneraccountnumberstate(arr);
    } else {
      let arr = [...owneraccountnumberstate];
      for (
        let i = GlobalConfiguration.lengthCheckZero;
        i < maxOwnerAccounts;
        i++
      ) {
        if (arr?.length < maxOwnerAccounts) {
          if (!owneraccountnumberstate?.includes(filteredData[i]?.id)) {
            if (filteredData[i]?.id) {
              arr.push(filteredData[i]?.id);
            }
          }
        }
      }
      setowneraccountnumberstate(arr);
    }
  };

  const handleSelectAllNonConsolidated = () => {
    const fd = splitView ? postiveBalanceData : filteredData;

    handleMultiSelectAll(
      isAssignTagsClicked ? assignTagsAccounts : labelAccounts,
      isAssignTagsClicked ? setAssignTagsAccounts : setLabelAccounts,
      multiSelect
        ? GlobalConfiguration.owneraccountnormalLength
        : selectedValue,
      fd,
    );
  };
  const handleOwnerAccountSelect = (account) => {
    if (isAssignTagsClicked) {
      handleSingleSelect(
        assignTagsAccounts,
        setAssignTagsAccounts,
        selectedValue,
        { ...account, id: account?.id },
      );
    } else if (isLabelClicked) {
      handleSingleSelect(labelAccounts, setLabelAccounts, selectedValue, {
        ...account,
        id: account?.id,
      });
    } else if (multiSelect) {
      const setOwnerAccountStateFromObjects = (update) => {
        if (typeof update === "function") {
          setowneraccountnumberstate((prevIds) => {
            const prevObjects = prevIds?.map((id) => ({ id })) || [];
            const nextObjects = update(prevObjects);
            return nextObjects?.map((item) => item?.id) || [];
          });
        } else {
          setowneraccountnumberstate(update?.map((item) => item?.id) || []);
        }
      };
      const currentAsObjects =
        owneraccountnumberstate?.map((id) => ({
          id,
        })) || [];

      handleSingleSelect(
        currentAsObjects,
        setOwnerAccountStateFromObjects,
        GlobalConfiguration.owneraccountnormalLength,
        { ...account, id: account?.id },
      );
    }
  };

  useEffect(() => {
    const isFullySelected = (selectedArray) => {
      return selectedArray?.length === Number(selectedValue);
    };

    let currentSelectionStatus = false;

    if (isAssignTagsClicked) {
      currentSelectionStatus = isFullySelected(assignTagsAccounts);
    } else if (isLabelClicked) {
      currentSelectionStatus = isFullySelected(labelAccounts);
    }

    setAllSelected(currentSelectionStatus);
  }, [
    assignTagsAccounts,
    labelAccounts,
    isAssignTagsClicked,
    isLabelClicked,
    selectedValue,
  ]);

  const handleClose = () => {
    setIsTagsPopupOpen(false);

    if (tagActionDispatchedRef.current) {
      fetchData();
      setAssignTagsAccounts([]);
      setIsAssignTagsClicked(false);
    }
  };

  const handleCloseAccount = async () => {
    setIsLabelPopupOpen(false);

    if (labelActionDispatchedRef.current) {
      await fetchData();
      labelActionDispatchedRef.current = false;
    }

    setLabelAccounts([]);
    setisLabelClicked(false);
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);

    const res = await dispatch(
      ownerAccountsAddLabel({
        record_ids: labelAccountIds?.length
          ? labelAccountIds
          : toArray(labelAccounts),
        labels: labelsToAssign,
      }),
    );

    if (ownerAccountsAddLabel.fulfilled.match(res)) {
      await fetchData();
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setLabelAccounts((prev) =>
        prev.map((account) => ({
          ...account,
          labels: [...new Set([...(account.labels || []), ...labelsToAssign])],
        })),
      );

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (ownerAccountsAddLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLoading(false);
    if (ownerAccountsAddLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      ownerAccountsRemoveLabel({
        record_ids: labelAccountIds?.length
          ? labelAccountIds
          : toArray(labelAccounts),
        labels: labelsToUnassign,
      }),
    );

    if (ownerAccountsRemoveLabel.fulfilled.match(res)) {
      await fetchData();
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (ownerAccountsRemoveLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (ownerAccountsRemoveLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleSubmit = (key, value) => {
    if (typepop !== "popup") {
      handleSearchParams(key, value);
    }
  };

  return (
    <>
      {isTagsPopupOpen && (
        <div
          onClick={() => {
            setIsTagsPopupOpen(false);
          }}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
        >
          <CommonAssignTagPopup
            headerTitle="Assign/Unassign tags:"
            closehandleFunction={handleClose}
            closedisabledBgColor=""
            closebuttonRef=""
            closeimgColor=""
            loading={loading}
            newTags={newSelectedTags}
            handleAddTags={handleAddTags}
            handleRemoveTags={handleRemoveTags}
            setNewTags={setNewSelectedTags}
            AllTags={AllTags}
            setAllTags={setAllTags}
            setLoading={setLoading}
            selectedAssignedAccountID={selectedAssignedAccountID}
            selectedAccount={selectedAccount}
            setSelectedAccount={setSelectedAccount}
            setSelectedAssignedAccountID={setSelectedAssignedAccountID}
            ownerDetailData={[
              ...new Map(allData.map((item) => [item["id"], item])).values(),
            ].filter((account) => assignTagsAccountIds.includes(account.id))}
            type="ownerViewAll"
          />
        </div>
      )}

      <>
        {/* Todo  */}
        {viewStatementOpenPop && (
          <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="View bank statement"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={() => setViewstatementOpenPop(false)}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              fullviewisDisabled={false}
              fullviewdisabledBgColor={""}
              isfullViewrequired={true}
              fullviewhandleFunction={() => {
                setViewstatementOpenPop(false);
                navigate(
                  `/owner_account_dashboard/consolidated_bank_statement/`,
                  {
                    state: {
                      startDate: bankStatementStartDate,
                      endDate: bankStatementEndDate,
                      ownerId: statementId,
                    },
                  },
                );
              }}
              enabledBgColor={"var(--negative-act)"}
              hoverOption={"dark"}
              enabledTextColor={"var(--text-primary)"}
              fullWidthRequired={true}
              isDisabled={false}
            >
              <OwnerAllStatement
                popType={"remitterBankStatement"}
                flow={"ownerDetail"}
                ownerDetailId={statementId}
                ownerDetailData={accData}
                setViewstatementOpenPop={setViewstatementOpenPop}
              />
            </LargePopupRedirect>
          </div>
        )}
        {
          // {/* Todo  */}
        }

        {isLabelPopupOpen && (
          <div className="fixed top-top-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
            <CommonAssignLabelPopup
              headerTitle="Assign/Unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated accounts."
              closehandleFunction={handleCloseAccount}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={labelAccounts}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={labelAccounts}
              onClose={handleCloseAccount}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
              type="viewall"
            />
          </div>
        )}

        {refreshAll && (
          <div
            className={`${refreshAll ? "refresh-transition-open" : "refresh-transition-close"} Qsmd:z-z-index-dropdown z-z-index-modal ${typepop === "popup" ? "Qsmd:top-[var(--popup-refresh-progress-bar-height)]  " : "top-top-base Qsmd:top-[var(--navbar-breadcrumb-height)] "}    px-padding-sm  Qsmd:h-[var(--timeline-height-sm)] h-[var(--topnavbar-refresh-progress-bar-height)] flex flex-col justify-center items-center`}
          >
            {/* Todo  */}
            <OwnerAccountRefreshAllLoader
              setRefreshAll={setRefreshAll}
              data={accumulatedData.filter((account) => {
                return account.connected_banking === "Y";
              })}
              setAccumulatedData={setAccumulatedData}
              mainData={filteredData}
              total_balance_state={total_balance_state}
              setTotal_balance_state={setTotal_balance_state}
              setFailedRefreshId={setFailedRefreshId}
              setSuccessRefreshId={setSuccessRefreshId}
            />
          </div>
        )}

        <div
          className={`bg-primary-bg flex flex-col ${typepop === "popup" ? "h-full" : "h-screen"}  overflow-hidden relative z-z-index-header`}
        >
          <div className="z-z-index-dropdown">
            <div
              className={`h-navbar-breadcrumb-height z-z-index-header ${
                typepop === "popup" ? "hidden" : "Qsmd:flex hidden"
              } ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"}`}
            ></div>

            <div
              className={`absolute bg-primary-nav bottom-bottom-base w-full rounded-none
                ${
                  showInnerSearchBar
                    ? "z-z-index-dropdown pointer-events-none"
                    : "z-z-index-dropdown"
                }
                ${showInnerSearchBar && "pointer-events-none"}`}
            >
              {accumulatedData?.length > GlobalConfiguration?.lengthCheckZero &&
                filteredData?.length > GlobalConfiguration?.lengthCheckZero && (
                  <div className={`${showInnerSearchBar && "h-height-full"}`}>
                    {showInnerSearchBar && (
                      <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-header" />
                    )}
                    <PaginationComponent
                      handleSelect={handleSelect}
                      selectedValue={selectedValue}
                      data={mainData}
                      pageSize={pageSize}
                      dropdownOptions={dropdownOptions}
                      handlePagination={handlePagination}
                      currentPage={currentPage}
                      setIsOpen={setIsOpen}
                      typePopup={typepop === "popup"}
                    />
                  </div>
                )}
            </div>
            <TopNavComponentWithBalance
              direction={direction}
              loading={loading}
              ispagination={
                accumulatedData?.length >=
                  GlobalConfiguration?.lengthCheckOne ||
                filteredData?.length >= GlobalConfiguration?.lengthCheckOne
                  ? true
                  : false
              }
              topNavCtaBtn1Needed={false}
              topNavCtaBtn1Props={
                isAssignTagsClicked || isLabelClicked || multiSelect
                  ? {
                      btnText:
                        activeSelectionCount >
                        GlobalConfiguration.lengthCheckZero
                          ? "Clear"
                          : "Cancel",
                      btnType: "button",
                      enabledBgColor: "var(--primary-nav-act)",
                      handleFunction: (e) => {
                        if (multiSelect) {
                          setowneraccountnumberstate([]);
                        } else {
                          const textContent = e.target.textContent.trim();
                          setAllSelected(false);
                          if (textContent === "Clear") {
                            setAssignTagsAccounts([]);
                            setLabelAccounts([]);
                            return;
                          } else if (textContent === "Cancel") {
                            setIsAssignTagsClicked(false);
                            setisLabelClicked(false);

                            handleScrollToTop();
                            setCurrentPage(GlobalConfiguration.lengthCheckOne);
                          }
                        }
                      },
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: multiSelect
                        ? owneraccountnumberstate?.length ===
                            GlobalConfiguration.lengthCheckZero ||
                          showInnerSearchBar
                        : showInnerSearchBar,
                      hoverOption: "black",
                    }
                  : null
              }
              topNavCtaBtn2Needed={false}
              topNavCtaBtn2Props={
                isAssignTagsClicked || isLabelClicked || multiSelect
                  ? {
                      btnText: isAssignTagsClicked
                        ? "Assign tags"
                        : multiSelect
                          ? "Confirm"
                          : "Assign labels",
                      btnType: "button",
                      enabledBgColor:
                        multiSelect && !activeSelectionCount
                          ? "var(--text-disabled)"
                          : activeSelectionCount
                            ? "var(--text-primary)"
                            : "var(--text-disabled)",
                      handleFunction: (e) => {
                        e.stopPropagation();
                        if (multiSelect) {
                          if (activeSelectionCount) {
                            if (
                              !owneraccountNumber?.length &&
                              !owneraccountDefaultNumber?.length
                            ) {
                              setDefaultAccountNumber(owneraccountnumberstate);
                              setownerAccountNumber(owneraccountnumberstate);
                              setowneraccountnumberstate(
                                owneraccountnumberstate,
                              );
                            } else if (owneraccountnumberstate?.length) {
                              setownerAccountNumber(owneraccountnumberstate);
                            }
                            onClosed(false);
                          }
                        } else {
                          if (assignTagsAccounts?.length) {
                            setIsTagsPopupOpen(true);
                          } else if (labelAccounts?.length) {
                            setIsLabelPopupOpen(true);
                          }
                        }
                      },
                      enabledTextColor:
                        multiSelect && !activeSelectionCount
                          ? "var(--text-primary)"
                          : activeSelectionCount
                            ? "var(--primary-bg)"
                            : "var(--text-primary)",
                      hoverOption: "black",
                      inActiveVariantNeeded: true,

                      isDisabled:
                        multiSelect && !activeSelectionCount
                          ? true
                          : activeSelectionCount
                            ? false
                            : true,
                    }
                  : null
              }
              topNavHeader={total_balance_state}
              topNavSubText={"Total balance"}
              BalanceStateRequired={
                isAssignTagsClicked || isLabelClicked || multiSelect
                  ? false
                  : true
              }
              BottomSubTextVaraint={"primary"}
              BottomSubText={
                multiSelect
                  ? undefined
                  : isAssignTagsClicked
                    ? "Select accounts to apply tags. Tagged users will gain access to view only owner accounts that share the same tags."
                    : isLabelClicked
                      ? "Select accounts to apply labels. These labels will be used to generate statistics for the associated accounts."
                      : undefined
              }
              isSelectionView={
                isAssignTagsClicked || isLabelClicked || multiSelect
              }
              isToggleNeeded={false}
              toggleProps={
                !multiSelect && !isLabelClicked && !isAssignTagsClicked
                  ? {
                      state: toggle,
                      title: !toggle ? " List view" : "Grid view",
                      isDisabled: showInnerSearchBar,
                      handleClick: (e) => {
                        e.stopPropagation();
                        if (scrollContainerRef.current) {
                          scrollContainerRef.current.scrollTop =
                            GlobalConfiguration.lengthCheckZero;
                        }
                        setFailedRefreshId([]);
                        setSuccessRefreshId([]);

                        if (toggle) {
                          dispatch(setToggle(false));
                        } else {
                          dispatch(setToggle(true));
                        }
                      },
                    }
                  : undefined
              }
              selectionText={
                isAssignTagsClicked || isLabelClicked || multiSelect
                  ? `Accounts selected: ${
                      activeSelectionCount ||
                      GlobalConfiguration.lengthCheckZero
                    }`
                  : ""
              }
              selectionBtnProps={
                (isAssignTagsClicked || isLabelClicked || multiSelect) &&
                (filteredData.length ||
                  postiveBalanceData.length ||
                  negativeBalanceData.length)
                  ? {
                      btnText: multiSelect
                        ? "Select up to 10"
                        : `Select up to ${Number(selectedValue)}`,
                      btnType: "button",
                      handleFunction: () => {
                        if (multiSelect && filteredData?.length) {
                          handleSelectAll();
                        } else if (isAssignTagsClicked || isLabelClicked) {
                          handleSelectAllNonConsolidated();
                        }
                      },
                      enabledBgColor: multiSelect
                        ? isMultiSelectLimitReached
                          ? "var(--positive-bg)"
                          : "var(--primary-nav-act)"
                        : (
                              splitView
                                ? postiveBalanceData.length ===
                                    GlobalConfiguration?.lengthCheckZero &&
                                  negativeBalanceData.length ===
                                    GlobalConfiguration?.lengthCheckZero
                                : filteredData.length ===
                                  GlobalConfiguration?.lengthCheckZero
                            )
                          ? "var(--primary-nav-act)"
                          : allSelected
                            ? "var(--positive-bg)"
                            : "var(--primary-nav-act)",

                      hoverOption: multiSelect
                        ? isMultiSelectLimitReached
                          ? "black"
                          : "white"
                        : allSelected
                          ? "black"
                          : "white",
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: splitView
                        ? postiveBalanceData.length ===
                            GlobalConfiguration?.lengthCheckZero &&
                          negativeBalanceData.length ===
                            GlobalConfiguration?.lengthCheckZero
                        : filteredData.length ===
                          GlobalConfiguration?.lengthCheckZero,
                      icon:
                        allSelected &&
                        (splitView
                          ? postiveBalanceData.length >
                              GlobalConfiguration?.lengthCheckZero ||
                            negativeBalanceData.length >
                              GlobalConfiguration?.lengthCheckZero
                          : filteredData.length >
                            GlobalConfiguration?.lengthCheckZero)
                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                          : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                    }
                  : undefined
              }
              iconComponentArray={
                !multiSelect
                  ? [
                      {
                        enabledBgColor: "var(--primary-bg)",
                        isLoading: loading,
                        handleFunction: (e) => {
                          if (!showInnerSearchBar) {
                            e.stopPropagation();
                            if (
                              services?.includes("VAccountBalance") ||
                              services?.includes("Admin")
                            ) {
                              setRefreshAllData([]);
                              setTimeout(() => {
                                let selectedData = accumulatedData?.map(
                                  (item) => {
                                    return {
                                      id: item.id,
                                      prevbalance: item?.owner_account_balance,
                                    };
                                  },
                                );
                                setFailedRefreshId([]);
                                setSuccessRefreshId([]);
                                setRefreshtype("all");
                                setPrev_Total_balance_state(
                                  total_balance_state,
                                );
                                setRefreshAllData(selectedData);
                                setRefreshAll(true);
                              }, 500);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "VAccountBalance,Admin",
                                },
                              });
                            }
                          }
                        },
                        isDisabled:
                          showInnerSearchBar &&
                          (services?.includes("VAccountBalance") ||
                            services?.includes("Admin")),
                        icon: ICONS?.RELOAD_REFRESH_WHITE,
                        title: "Refresh all balances",
                        hoverOption: "white",
                      },
                    ]
                  : undefined
              }
              AllPageRefresh={
                failedRefreshId.length > GlobalConfiguration.lengthCheckZero ||
                successRefreshId?.length > GlobalConfiguration.lengthCheckZero
              }
              failedRefreshId={failedRefreshId}
              successRefreshId={successRefreshId}
              selectAmtType={selectAmtType}
              prevBalance={prev_total_balance_state}
              TotalBalance={total_balance_state}
              ownerAccBalanceLoading={ownerAccBalanceLoading}
              assignLabelNeeded={true}
              assignTagNeeded={true}
              assignLabelProps={
                !isLabelClicked && !multiSelect
                  ? {
                      handleFunction: () => {
                        if (
                          showInnerSearchBar ||
                          (!services?.includes("ALabel") &&
                            !services?.includes("RLabel")) ||
                          isAssignTagsClicked
                        )
                          return;
                        if (typepop === "popup") {
                          actionRestricted();
                        } else if (
                          services?.includes("ALabel") &&
                          services?.includes("RLabel")
                        ) {
                          setisLabelClicked((prev) => {
                            if (prev) {
                              setLabelAccounts([]);
                            }
                            return !prev;
                          });
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "ALabel,RLabel",
                            },
                          });
                        }
                      },
                      isDisabled:
                        showInnerSearchBar ||
                        (!services?.includes("ALabel") &&
                          !services?.includes("RLabel")) ||
                        isAssignTagsClicked ||
                        typepop === "popup",
                      enabledBgColor: "var(--primary-bg)",
                      isLoading: false,
                      hoverOption: "white",
                      buttonRef: null,
                      title:
                        "Labels will be used to generate statistics for the associated accounts",
                    }
                  : undefined
              }
              assignTagProps={
                !isAssignTagsClicked && !multiSelect
                  ? {
                      handleFunction: () => {
                        if (
                          isLabelClicked ||
                          (!services?.includes("COwnerTag") &&
                            !services?.includes("DOwnerTag")) ||
                          showInnerSearchBar
                        )
                          return;

                        if (typepop === "popup") {
                          actionRestricted();
                          return;
                        }

                        if (
                          !services?.includes("COwnerTag") &&
                          !services?.includes("DOwnerTag")
                        ) {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: !services?.includes(
                                "COwnerTag",
                              )
                                ? "COwnerTag"
                                : "DOwnerTag",
                            },
                          });
                        }

                        handleScrollToTop();
                        setIsAssignTagsClicked(true);
                      },
                      isDisabled:
                        (!services?.includes("COwnerTag") &&
                          !services?.includes("DOwnerTag")) ||
                        isLabelClicked ||
                        showInnerSearchBar ||
                        typepop === "popup",
                      enabledBgColor: "var(--primary-bg)",
                      isLoading: false,

                      hoverOption: "white",
                      buttonRef: null,
                      title:
                        "Tags will be used to give access of owner accounts to the users who share even one of the assigned tags.",
                    }
                  : undefined
              }
              filteredSearchProps={{
                setShowInnerSearchBar: setShowInnerSearchBar,
                showInnerSearchBar: showInnerSearchBar,
                isSearchDisabled: loading,
                onSearchInput: (val) => {
                  setsearchUserTextDebounce(val);
                },

                searchText: searchUserTextDebounce,
                searchPlaceholder: globalText.SEARCH_OWNER_ACCOUNT,
                filterPlaceholder: "owner account ID/ name/ email ID",
                filterItems: [
                  {
                    name: "Search",
                    isMulti: false,
                    value: searchUserText,
                    setValue: (val) => {
                      setSearchUserText(val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("search", val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },

                  {
                    name: "Account number",
                    short_name: "Acc .no",
                    isMulti: false,
                    value: accountnumberstate,
                    setValue: (val) => {
                      handleSubmit("accno", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setaccountnumberstate(val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },
                  {
                    name: "IFSC code",
                    short_name: "IFSC",
                    isMulti: false,
                    value: ifscstate,
                    setValue: (val) => {
                      handleSubmit("ifsc", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setifscstate(val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },
                  {
                    name: "Bank name",
                    isMulti: false,
                    value: bankstate,
                    setValue: (val) => {
                      handleSubmit("bank", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setbankstate(val);
                    },
                    isDropdown: true,
                    isDisabled: loading,
                    isAlphabetical: true,
                  },
                  {
                    name: "PAN number",
                    short_name: "Pan",
                    isMulti: false,
                    value: panstate,
                    setValue: (val) => {
                      handleSubmit("pan", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setpanstate(val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },
                  {
                    name: "Labels",
                    short_name: "Lab",
                    isMulti: true,
                    value: labelsFilter,
                    setValue: (val) => {
                      handleSubmit("label", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setFilterLabels(val);
                    },
                    isDropdown: true,
                    isDisabled: loading,
                  },
                  {
                    name: "Tags",
                    short_name: "Tag",
                    isMulti: true,
                    value: ownerTagState,
                    setValue: (val) => {
                      handleSubmit("tag", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setOwnerTagState(val);
                    },
                    isDropdown: true,
                    isDisabled: loading,
                  },
                ],
                filters: [
                  {
                    name: "Type of account",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: [
                      "Current account",
                      "Overdraft account",
                      "Cash credit account",
                      "Fixed deposit account",
                    ],

                    dropdownPlaceHolder: "Select type",
                    value: typeaccountstate,
                    isDisable: false,
                    handleChange: (val) => {
                      handleSubmit("acctype", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      settypeaccountstate(val);
                    },
                  },

                  {
                    name: "Connected banking",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["Active", "Inactive"],
                    isDisabled:
                      typepop === "popup" && flow !== "internalTxn"
                        ? true
                        : false,
                    dropdownPlaceHolder: "Select status",
                    value: connectedbankingstate,
                    handleChange: (val) => {
                      handleSubmit("connectbank", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setConnectedbankingstate(val);
                    },
                  },

                  {
                    name: "Favourite",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["Show only favourite", "Hide favourite"],
                    isDisabled: false,
                    dropdownPlaceHolder: "Default (all accounts)",
                    value: favouritesFilter,
                    handleChange: (val) => {
                      handleSubmit("favourite", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setFavouritesFilter(val);
                    },
                  },
                ],
                sortByFilter: [
                  {
                    name: "Newest",
                    default: true,
                    isDisabled: false,
                  },
                  {
                    name: "Oldest",
                    default: false,
                    isDisabled: false,
                  },
                  {
                    name: "Balance : High to low",
                    isDisabled: false,
                  },
                  {
                    name: "Balance : Low to high",
                    isDisabled: false,
                  },
                ],
                sortValue:
                  accountbalancestate || (sortBy === "oldest" ? "Oldest" : ""),
                sortHandleChange: (val) => {
                  if (val === "Oldest" || !val?.length) {
                    const mappedVal = val === "Oldest" ? "oldest" : "latest";
                    handleSubmit("sort_by", mappedVal);
                    handleSubmit("sort", "");
                    setSortBy(mappedVal);
                    setaccountbalancestate("");
                  } else {
                    handleSubmit("sort", val);
                    handleSubmit("sort_by", "");
                    setaccountbalancestate(val);
                    setSortBy("");
                  }

                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                },
                isSortDefaultDisabled:
                  sortBy === "latest" ||
                  (sortBy === "" && accountbalancestate === "") ||
                  loading,
                isFilterClearAllDisabled: !(
                  (connectedbankingstate?.length && typepop !== "popup") ||
                  typeaccountstate?.length ||
                  favouritesFilter?.length ||
                  bankstate?.length ||
                  loading
                ),

                isSearchClearAllDisabled: !(
                  accountnumberstate?.length ||
                  panstate?.length ||
                  searchUserText?.length ||
                  labelsFilter?.length ||
                  ownerTagState?.length ||
                  ifscstate?.length ||
                  loading
                ),

                inputData: inputData,
                active: active,
                setActive: setActive,
                loading: loading,
                setLoading: setLoadingData,
                isShowSortBy: true,
                isShowFilter: true,
                loadingData: loadingData,
              }}
            />
            {/* ------------------------ */}
          </div>
          <div
            className={
              showInnerSearchBar
                ? `h-screen ownerviewallscroll flex flex-col opacity-dark-opacity bg-PopUp-BackDrop pointer-events-none w-full z-z-index-content Qsmd:z-z-index-header ${isEmptyDataState ? "overflow-y-hidden pb-padding-xl mt-margin-xs" : ""}`
                : isEmptyDataState
                  ? "overflow-y-hidden h-screen Qsmd:pb-padding-xs pb-padding-base ownerviewallscroll mt-margin-xs mb-margin-base Qsmd:mb-margin-xs"
                  : `flex-1 ${isLabelClicked || isAssignTagsClicked || multiSelect ? "mb-[var(--topnav-bottom-height)] Qsmd:mb-[var(--pagination-height)]" : "mb-[var(--pagination-height)]"} overflow-y-auto relative z-z-index-content`
            }
            style={{
              scrollPaddingTop: "var(--padding-md)",
              scrollPaddingBottom: "var(--padding-md)",
            }}
            ref={setScrollableContainerRef}
            onScroll={handleScroll}
          >
            <div
              className={`${showInnerSearchBar || loading || !filteredData?.length || !accumulatedData?.length ? "overflow-y-scroll overflow-x-hidden" : ""} h-full flex flex-col`}
            >
              <div
                className={`${showInnerSearchBar && "opacity-light-opacity bg-PopUp-BackDrop z-z-index-base pointer-events-none relative"} mx-auto w-width-full max-w-tab-width-normal my-margin-base mt-margin-md px-padding-sm Qlg:p-padding-base`}
              >
                <SwitcherTabsWithSplitView
                  initialActiveTab="Default"
                  tabs={[
                    {
                      label: "Default",
                      key: "Default",
                      handler: () => setSelectAmtType("Default"),
                    },
                    {
                      label: "Lakhs (L)",
                      key: "Lakhs",
                      handler: () => setSelectAmtType("Lakhs"),
                    },
                    {
                      label: "Crores (Cr)",
                      key: "Crores",
                      handler: () => setSelectAmtType("Crores"),
                    },
                    {
                      label: "Millions (M)",
                      key: "Millions",
                      handler: () => setSelectAmtType("Millions"),
                    },
                    {
                      label: "Billions (B)",
                      key: "Billions",
                      handler: () => setSelectAmtType("Billions"),
                    },
                  ]}
                  isDisabled={showInnerSearchBar}
                  swicherTabBgColor={"var(--primary-card)"}
                  handleClick={(e) => {
                    e.stopPropagation();
                    splitView == ""
                      ? setSplitView(true)
                      : setSplitView(!splitView);
                  }}
                  state={splitView}
                  splitViewtype={"splitView"}
                />
              </div>

              <div
                className={`${
                  showInnerSearchBar ? "overflow-y-hidden" : ""
                } flex-1 ${
                  accumulatedData?.length ===
                  GlobalConfiguration.lengthCheckZero
                    ? "mb-bottom-base mt-margin-md"
                    : isLabelClicked || isAssignTagsClicked || multiSelect
                      ? "Qsmd:mb-[var(--pagination-height)] mb-topnav-bottom-height"
                      : ""
                }`}
                style={{
                  height:
                    (!filteredData?.length || !accumulatedData?.length) &&
                    "var(--height-full)",
                }}
              >
                {loading ? (
                  <div className="flex flex-col items-center justify-center h-height-full ">
                    <Loader />
                  </div>
                ) : filteredData?.length ||
                  accumulatedData?.length ||
                  splitView ? (
                  <div
                    className={`flex flex-col min-h-height-base h-full items-center ${showInnerSearchBar && "pointer-events-none"} w-full   ${
                      showInnerSearchBar &&
                      "overflow-y-hidden opacity-light-opacity"
                    }`}
                  >
                    {!toggle ? (
                      <OwnerAccountViewAllCard
                        filterRef={filterRef}
                        typepop={typepop}
                        handleButtonClick={handleButtonClick}
                        setIsNeft={setIsNeft}
                        setIsImps={setIsImps}
                        flow={flow}
                        setIsRtgs={setIsRtgs}
                        txnPayLoad={txnPayLoad}
                        setTxnPayLoad={setTxnPayLoad}
                        setpaymentBox={setpaymentBox}
                        BenEnableNextButton={BenEnableNextButton}
                        setOpenOwner={setOpenOwner}
                        isopen={showInnerSearchBar}
                        setFailedRefreshId={setFailedRefreshId}
                        failedRefreshId={failedRefreshId}
                        successRefreshId={successRefreshId}
                        setSuccessRefreshId={setSuccessRefreshId}
                        handleRefresh={handleRefresh}
                        data={filteredData}
                        page={currentPage}
                        refreshAllData={refreshAllData}
                        refreshType={refreshType}
                        setRefreshtype={setRefreshtype}
                        setPrev_Total_balance_state={
                          setPrev_Total_balance_state
                        }
                        total_balance={total_balance_state}
                        currency={selectAmtType}
                        splitView={splitView}
                        postiveBalanceData={postiveBalanceData}
                        negativeBalanceData={negativeBalanceData}
                        refreshAll={refreshAll}
                        handleViewStatement={handleViewStatement}
                        setStatementId={setStatementId}
                        accData={accData}
                        setAccData={setAccData}
                        multiSelect={multiSelect}
                        isAssignTagsClicked={isAssignTagsClicked}
                        isLabelClicked={isLabelClicked}
                        handleOwnerAccountSelect={handleOwnerAccountSelect}
                        owneraccountnumberstate={
                          isAssignTagsClicked
                            ? assignTagsAccounts
                            : isLabelClicked
                              ? labelAccounts
                              : owneraccountnumberstate
                        }
                        setowneraccountnumberstate={
                          isAssignTagsClicked
                            ? setAssignTagsAccounts
                            : isLabelClicked
                              ? setLabelAccounts
                              : setowneraccountnumberstate
                        }
                        popType={popType}
                        favouritesFilter={favouritesFilter}
                        setRefactorAccDetail={setRefactorAccDetail}
                        type={type}
                        selectedLabelsCreate={selectedLabelsCreate}
                        TypeRTGS={TypeRTGS}
                        currentAccountDetails={currentAccountDetails}
                      />
                    ) : (
                      <OwnerAccountListView
                        filterRef={filterRef}
                        typepop={typepop}
                        handleButtonClick={handleButtonClick}
                        setIsNeft={setIsNeft}
                        setIsImps={setIsImps}
                        setIsRtgs={setIsRtgs}
                        flow={flow}
                        txnPayLoad={txnPayLoad}
                        setTxnPayLoad={setTxnPayLoad}
                        setpaymentBox={setpaymentBox}
                        BenEnableNextButton={BenEnableNextButton}
                        setOpenOwner={setOpenOwner}
                        handleRefresh={handleRefresh}
                        data={filteredData}
                        isopen={showInnerSearchBar}
                        page={currentPage}
                        refreshAllData={refreshAllData}
                        refreshType={refreshType}
                        setRefreshtype={setRefreshtype}
                        setFailedRefreshId={setFailedRefreshId}
                        failedRefreshId={failedRefreshId}
                        successRefreshId={successRefreshId}
                        setSuccessRefreshId={setSuccessRefreshId}
                        setPrev_Total_balance_state={
                          setPrev_Total_balance_state
                        }
                        total_balance={total_balance_state}
                        currency={selectAmtType}
                        splitView={splitView}
                        postiveBalanceData={postiveBalanceData}
                        negativeBalanceData={negativeBalanceData}
                        refreshAll={refreshAll}
                        handleViewStatement={handleViewStatement}
                        setStatementId={setStatementId}
                        accData={accData}
                        setAccData={setAccData}
                        favouritesFilter={favouritesFilter}
                        multiSelect={multiSelect}
                        isAssignTagsClicked={isAssignTagsClicked}
                        isLabelClicked={isLabelClicked}
                        handleOwnerAccountSelect={handleOwnerAccountSelect}
                        owneraccountnumberstate={
                          isAssignTagsClicked
                            ? assignTagsAccounts
                            : isLabelClicked
                              ? labelAccounts
                              : owneraccountnumberstate
                        }
                        setowneraccountnumberstate={
                          isAssignTagsClicked
                            ? setAssignTagsAccounts
                            : isLabelClicked
                              ? setLabelAccounts
                              : setowneraccountnumberstate
                        }
                        popType={popType}
                        setRefactorAccDetail={setRefactorAccDetail}
                        type={type}
                        selectedLabelsCreate={selectedLabelsCreate}
                        TypeRTGS={TypeRTGS}
                        currentAccountDetails={currentAccountDetails}
                      />
                    )}
                  </div>
                ) : (
                  <>
                    {showInnerSearchBar && (
                      <div className="absolute bg-PopUp-BackDrop h-full opacity-dark-opacity pointer-events-none w-full z-z-index-header"></div>
                    )}
                    <div
                      className={`flex flex-col items-center justify-center Qmd:m-auto mx-auto Qsmd:my-margin-base my-margin-base h-height-full gap-gap-sm ${
                        !showInnerSearchBar && multiSelect ? "h-auto" : ""
                      }`}
                    >
                      <img
                        src={ICONS?.NO_DATA_FOUND}
                        alt="No accounts found"
                        className={
                          "w-graphic-width-md h-graphic-rectangle-height-md"
                        }
                      />
                      <p
                        className={
                          "text-font-sm text-text-primary items-center"
                        }
                      >
                        No data found.
                      </p>
                      <div
                        style={{
                          display:
                            favouritesFilter ||
                            searchUserText?.length ||
                            connectedbankingstate?.length ||
                            accountbalancestate?.length ||
                            ownerTagState?.length ||
                            labelsFilter?.length ||
                            typeaccountstate?.length ||
                            bankstate?.length ||
                            panstate?.length ||
                            accountnumberstate?.length ||
                            ifscstate?.length
                              ? "flex"
                              : "none",
                        }}
                      >
                        <PrimaryButton
                          isDisabled={false}
                          enabledBgColor="var(--primary-act)"
                          btnText="Clear parameters"
                          enabledTextColor="var(--text-primary)"
                          handleFunction={(e) => {
                            e.stopPropagation();
                            handleClearSearchParam();
                            if (typepop === "popup") {
                              setConnectedbankingstate("Active");
                            } else {
                              setConnectedbankingstate("");
                            }
                            setFavouritesFilter("");
                            setSearchUserText("");
                            setsearchUserTextDebounce("");
                            setbankstate("");
                            settypeaccountstate("");
                            setaccountbalancestate("");
                            setaccountnumberstate("");
                            setifscstate("");
                            setpanstate("");
                            setOwnerTagState([]);
                            setFilterLabels([]);

                            setCurrentPage(GlobalConfiguration.lengthCheckOne);
                          }}
                          buttonRef={null}
                          hoverOption="white"
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default OwnerAccountViewAll;
